import hoverCard from './teaser-card-hover';

export default function initializeTeaserCards() {
  hoverCard();
}
